export const TRIGGER_ADD_EDIT_MODAL_ID = 'trigger-add-edit-modal';
